<template>
  <PullRefresh
    v-model="pullRefresh.loading"
    @refresh="onRefresh"
  >
    <List
      ref="list"
      v-model="list.loading"
      :dataList="dataList"
      :finished="list.finished"
      :error.sync="list.error"
      @load="onLoad"
    > 
      <template slot-scope="{ item }">
        <Card :data="item" />
      </template>
    </List>
  </PullRefresh>
</template>
<script>
import { PullRefresh, Toast } from 'vant'
import List from '_c/list'
import Card from '../card'
export default {
  components: {
    Card,
    List,
    PullRefresh
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    dataList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: {
        loading: false,
        finished: true,
        error: false
      },
      pullRefresh: {
        loading: false
      }
    }
  },
  methods: {
    onLoad() {
      this.$emit('on-load')
    },
    onRefresh() {
      this.onLoad()
      setTimeout(() => {
        if(this.$refs.list.loading) { 
            this.pullRefresh.loading = false
        }else{
          Toast('刷新失败')
        }
      }, 1000)
    }
  }
}
</script>
<style lang="less" scoped>
.van-pull-refresh {
  min-height: 100%;
}
.list {
  padding-top: 16px;

  .list-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .checkbox-wrap {
      padding: 0 24px;
    }

    .card-wrap {
      flex: 1;
    }
  }
}
</style>